import _extends from "@babel/runtime/helpers/extends";
import * as React from 'react';
export var IconSystemSocialYoutube = function IconSystemSocialYoutube(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M22.547 6.504c-.254-.98-.997-1.751-1.94-2.015C18.888 4 12 4 12 4s-6.886 0-8.608.47c-.924.264-1.685 1.055-1.939 2.034C1 8.292 1 12 1 12s0 3.727.453 5.497c.254.978.997 1.75 1.94 2.014C5.131 20 12 20 12 20s6.886 0 8.608-.47c.942-.264 1.685-1.036 1.939-2.015C23 15.727 23 12.02 23 12.02s.018-3.727-.453-5.515m-12.74 8.922V8.574L15.534 12z"
  }));
};